
import { Box } from "@mui/material";
import { DisenioPaginas } from "../../layout";
import { BuscadorSoloValor, CargandoMedio } from "../../components";
import { useCentrosCostoQuery } from "../../../hooks";
import { TablaCentroCostos } from "../../components/facturas";




export const ListadoCentroCosto = () => {


    const { data, isLoading, termino, chageTermino, chagePage, page } = useCentrosCostoQuery();



    return (

        <DisenioPaginas titulo="Listado de Centros Costo" url="cencos/new/add">
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando centros de costo..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} titulo='Buscar centro de costo...' place='Buscar x nombre...'/>
                <TablaCentroCostos data={data || []} chagePage={chagePage} page={page} />
                </>
            }
        </DisenioPaginas>

    )
}
